import React, { useEffect, useState } from 'react'
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast'
import $ from 'jquery';
import { actionDropdown, resetDropdownDataResponse } from '../../../../../common/store';
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from '../../../../../common/app_constant';
import ErrorLabel from "../../../../../component/error_label";
import { actionUploadKYCDocuments, resetUploadKYCDocumentsResponse } from '../store';


const UploadDocuments = (props) => {

    const dispatch = useDispatch()
    const navigation = useNavigate()

    const { dropdownData } = useSelector((state) => ({
        ...state.commonStore
    }))
    const { uploadKYCDocuments } = useSelector((state) => ({
        ...state.MyProfileStore
    }))
    const {
        register,
        formState: { errors },
        handleSubmit,
        getValues,
        setValue,
        watch,
        reset,
        control
    } = useForm({
        defaultValues: {
            document_type: '',
            upload_document: null
        },
    });

    const [allDropdownArr, setAllDropdownArr] = useState(null)

    useEffect(() => {
        if (props.isUploadDoc === true) {
            dispatch(actionDropdown())
        }

    }, [props.isUploadDoc])


    useEffect(() => {
        if (uploadKYCDocuments !== null) {
            dispatch(resetUploadKYCDocumentsResponse())
            if (uploadKYCDocuments.result === true) {
                toast.success(uploadKYCDocuments.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
                $("#app-body").attr("style", "");
                $("#root").removeClass("modal-open");
                $(".modal-backdrop").remove();
                setValue('document_type')
                setValue('title')
                props.isUploadDocClose()

            } else {
                switch (uploadKYCDocuments.status_code) {
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [uploadKYCDocuments])

    useEffect(() => {
        if (dropdownData !== null) {
            dispatch(resetDropdownDataResponse())
            if (dropdownData.result === true) {
                setAllDropdownArr(dropdownData.data)
            } else {
                switch (dropdownData.status) {

                }
            }
        }
    }, [dropdownData])

    const generateDocType = () => {
        var menu = [];
        if (allDropdownArr != null && allDropdownArr.document_type.length > 0) {
            allDropdownArr.document_type.forEach(function (child, labelIndex) {
                menu.push(
                    <option key={labelIndex} value={child.key}>
                        {child.value}
                    </option>
                );
            });
        }
        return menu;
    };

    const onSubmit = async (data) => {

        var input = {
            client_id: props.selectedItem,
            document_type: data.document_type,

        }

        var files = [];
        if (data.upload_document != null) {
            files.push({
                name: "upload_document",
                value: data.upload_document[0],
            });
        }
        dispatch(actionUploadKYCDocuments({ input, files }))

    };

    return (
        <>
            <div
                className="modal fade show"
                id="uploadDocument"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ display: props.isUploadDoc === true ? 'block' : 'none' }}

            >
                <div className="modal-dialog modal-dialog-centered">
                    <form
                        noValidate
                        autoComplete="off"
                        onSubmit={handleSubmit(
                            onSubmit
                        )}
                    >
                        <div className="modal-content">
                            <div className="modal-body ">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        Upload Documents</h5>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                                props.isUploadDocClose()
                                            }}
                                        >
                                            <i className="fa fa-close" />

                                        </button>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="documentType" className="form-label">
                                            Document Type<span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="document_type"
                                            className="form-control form-select"
                                            {...register(
                                                "document_type",
                                                {
                                                    required: "This is required."
                                                }
                                            )}
                                        >
                                            <option value="">Select Document Type</option>

                                            {generateDocType()}
                                        </select>
                                        {errors.document_type && (
                                            <ErrorLabel
                                                message={
                                                    errors
                                                        .document_type
                                                        ?.message
                                                }
                                            />
                                        )}
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="formFile" className="form-label">
                                            Attachment<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            accept=".gif,.png,.jpg,.doc,.docx,.pdf,.xlsx,.csv,.xls"

                                            {...register("upload_document", {
                                                required: "This is required.",
                                                validate: {
                                                    lessThan10MB: (files) => files[0]?.size < 5242880 || "Max size for image 5MB",
                                                    // acceptedFormats: (files) =>
                                                    //     ["image/jpg", "image/png", "image/gif"].includes(
                                                    //         files[0]?.type
                                                    //     ) || "only gif, png,jpg,doc,docx,pdf,xlsx,csv,xls images allowed."
                                                }
                                            })}
                                        // onChange={(event) => {
                                        //     if (event.target.files && event.target.files[0]) {
                                        //         var filesize = event.target.files[0].size;
                                        //         const file = Math.round((filesize / 1024));
                                        //         // The size of the file.
                                        //         if (file >= 5120) {
                                        //             alert('One or more files are bigger than 5mb');

                                        //         } if (file < 5120) {
                                        //             setAttachment(event.target.files[0])
                                        //         }
                                        //     }
                                        // }}
                                        />
                                        {errors.upload_document && (
                                            <ErrorLabel
                                                message={
                                                    errors
                                                        .upload_document
                                                        ?.message
                                                }
                                            />
                                        )}
                                    </div>
                                    <div className="col-12 mt-3">
                                        <small className="fs-7">
                                            *only gif, png,jpg,doc,docx,pdf,xlsx,csv,xls images allowed. Max
                                            size for image 5MB
                                        </small>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-sm  mt-3"
                                // data-bs-dismiss="modal"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </>
    )

}

export default UploadDocuments;